import {
  RegistrationOverviewChart,
  RegistrationOverviewChartType,
} from '@components/charts/RegistrationOverview'
import { FC, ReactNode } from 'react'

const RegistrationOverview: FC &
  RegistrationOverviewChartType = (): ReactNode => <></>

RegistrationOverview.Chart = RegistrationOverviewChart

export default RegistrationOverview
